import React from "react";
import { BiArrowBack } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { NewJobAction } from "../../Redux/action/NewJobAction";

const TableHeader = ({ isSearch, isFilter, heading,filterBtnTitle,placeholder,setInputState,inputState,filterRoute }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();


    const handleFilter = (e) => {
        // let response = axios.get
        dispatch(NewJobAction(inputState));
    }

    return (
        <>
            <div className="searchCanHead"></div>
            <div>
                <div
                    className="d-flex justify-content-around align-items-center g-xl-5"
                    role="button"
                    style={{
                        textAlign: "center",
                        padding: "20px",
                        marginTop: "0px",
                        gap: "390px",
                    }}
                >
                    <h2
                        className="d-flex align-items-center gap-1 "
                        style={{
                            padding: "5px",
                        }}
                        onClick={() => navigate(-1)}
                    >
                        <BiArrowBack />
                    </h2>
                    <h2 style={{ marginRight: "50px" }}>
                        <b>{heading}</b>
                    </h2>
                    <h1> </h1>
                </div>
            </div>

            {isSearch && <div
                className="searchCanFilter"
                style={{
                    width: "90%",
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "0 auto",
                    background: "#f6f6f6",
                    marginTop: "50px",
                }}
            >
                {isSearch && <div className="form-outline">
                    <input
                        type="search"
                        id="form1"
                        className="form-control-Job"
                        placeholder={placeholder ||"Search"}
                        aria-label="Search"
                        onChange={(e)=>setInputState(e.target.value)}
                    />
                </div>}
                {isFilter &&
                    <div style={{ marginTop: "9px" }}
                    >
                        <>
                            {filterRoute && <Link to="/create_job" className="pdtn">
                                <button type="button" className="Job_btn" onClick={handleFilter}>
                                    {filterBtnTitle ||  "Create New Job" }
                                </button>
                            </Link>}
                            {!filterRoute &&
                                <button type="button" className="Job_btn" onClick={handleFilter}>
                                    {filterBtnTitle ||  "Create New Job" }
                                </button>
                            }
                        </>
                    </div>}
            </div>}
        </>
    );
};

export default TableHeader;
